import React, { useState, useEffect, useRef } from 'react';

const ModalImageGallery = ({ images }) => {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const lightboxRef = useRef(null);

  const openLightbox = (index) => {
    setSelectedImageIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  const goToNextImage = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPreviousImage = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  // Handle click outside the modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (lightboxRef.current && !lightboxRef.current.contains(event.target)) {
        closeLightbox();
      }
    };

    if (isLightboxOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLightboxOpen]);

  return (
    <div className="w-full  flex flex-row gap-4 overflow-x-auto">
      {images.map((image, index) => (
        <div
          key={index}
          className="relative w-44 h-48 flex-shrink-0 border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer"
          onClick={() => openLightbox(index)}
        >
          <img
            src={typeof image === "string" ? image : URL.createObjectURL(image)}
            alt={`preview-${index}`}
            className="object-cover w-full h-full"
          />
        </div>
      ))}

      {isLightboxOpen && (
        <div className="fixed inset-0  bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 shadow-md">
          <div
            id="controls-carousel"
            className="relative  w-[60%] "
            data-carousel="static"
            ref={lightboxRef}
          >
            {/* Carousel wrapper */}
            <div className="relative h-[600px] overflow-hidden rounded-lg">
              {images.map((image, index) => (
                <div
                  key={index}
                  className={`duration-700 ease-in-out ${index === selectedImageIndex ? 'block' : 'hidden'}`}
                  data-carousel-item={index === selectedImageIndex ? 'active' : undefined}
                >
                  <img
                    src={typeof image === "string" ? image : URL.createObjectURL(image)}
                    alt={`lightbox-${index}`}
                    className="absolute block w-full  object-cover -translate-x-1/2 -translate-y-1/3 top-1/2 left-1/2"
                  />
                </div>
              ))}
            </div>
            {/* Slider controls */}
            <button
              type="button"
              className="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
              onClick={goToPreviousImage}
              data-carousel-prev
            >
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 group-hover:bg-white/50 group-focus:ring-4 group-focus:ring-white group-focus:outline-none">
                <svg
                  className="w-4 h-4 text-white rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 6 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 1 1 5l4 4"
                  />
                </svg>
                <span className="sr-only">Previous</span>
              </span>
            </button>
            <button
              type="button"
              className="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
              onClick={goToNextImage}
              data-carousel-next
            >
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 group-hover:bg-white/50 group-focus:ring-4 group-focus:ring-white group-focus:outline-none">
                <svg
                  className="w-4 h-4 text-white rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 6 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 9 4-4-4-4"
                  />
                </svg>
                <span className="sr-only">Next</span>
              </span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalImageGallery;